import { useNavigate } from "react-router-dom";
import ArrowSvg from "../../assets/svg/arrowSvg";
import { UserContext } from "../../context/UserContext";
import { useContext } from "react";
import { LoaderContext } from "../../context/LoaderContext";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";
import wanrningIcon from "../../assets/images/warning.png";
import { useState } from "react";
import { DELETE, GET, PATCH } from "../../utils/httpUtils";
import { Alert, GetLocalSetting, Log } from "../../utils/genericUtils";
import { AlertContext } from "../../context/AlertContext";

const defaultProps = {
  dir: "",
  forwardFileUploadClick: () => {},
  forwardFolderUploadClick: () => {},
  uploadFile: () => {},
  createFolder: () => {},
  forceRender: () => {},
};

export default function DashboardControls(props = defaultProps) {
  const router = useNavigate();
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);

  const [deleteAllModalActive, setDeleteAllModalActive] = useState(false);
  const [restoreAllModalActive, setRestoreAllModalActive] = useState(false);

  //click handler for delete all button
  function onDeleteAllClick() {
    //check if they set not to show again
    let dontAsk = GetLocalSetting("ask_permenantly_ask_delete") === false;
    Log("dont ask: ", dontAsk);
    if (dontAsk === false) setDeleteAllModalActive(true);
    else DeleteAll();
  }

  //delete all objects in the trash bin
  async function DeleteAll() {
    showloader();
    await DELETE("/empty-trash", undefined, user);
    setDeleteAllModalActive(false);
    props.forceRender();
    hideloader();
  }

  function DeleteSelected() {
    Alert(globalAlert, "info", "TO DO", "implement this function!");
  }

  function RestoreSelected() {
    Alert(globalAlert, "info", "TO DO", "implement this function!");
  }

  //click handler for delete all button
  function onRestoreAllClick() {
    //check if they set not to show again
    let dontAsk = GetLocalSetting("ask_restore_all_object") === false;
    Log("dont ask: ", dontAsk);
    if (dontAsk === false) setRestoreAllModalActive(true);
    else RestoreAll();
  }

  async function RestoreAll() {
    showloader();
    let response = await PATCH("/restore-all", undefined, user);
    hideloader();

    if (response.success) {
      props.forceRender();
      setRestoreAllModalActive(false);
    } else {
      if (response.error.message) {
        Alert(globalAlert, "error", "There was an error restoring one or more objects", response.error.message);
      } else {
        Alert(globalAlert, "error", "Something Went Wrong", "unkown error occurred try again later");
      }
    }
  }

  let dir_parts = props.dir.toLowerCase().split("/");
  if (dir_parts[0] === "trash" || dir_parts[1] === "trash") {
    return (
      <div className="dashboard-buttons">
        {/* Permenantly Delete All Modal */}
        <ConfirmationModal
          iconAsButton={false}
          icon={wanrningIcon}
          isActive={deleteAllModalActive}
          includeDontAskAgain={true}
          dontAskSetting={"ask_permenantly_ask_delete"}
          animate={true}
          id={"trash-bin-modal-" + props.id}
          header={"Warning"}
          message={"All files and folders in the trash bin will be permenantly deleted!"}
          onDeny={() => setDeleteAllModalActive(false)}
          onConfirm={DeleteAll}
          confirmText="Delete Forever"
          denyText="Cancel"
        />

        {/* Restore All Object Modal */}
        <ConfirmationModal
          isActive={restoreAllModalActive}
          includeDontAskAgain={true}
          dontAskSetting={"ask_restore_all_object"}
          animate={true}
          id={"restore-object-modal-" + props.id}
          header={"Are You Sure?"}
          message={"All files and folders in the trash bin will be restored to their original directories"}
          onDeny={() => setRestoreAllModalActive(false)}
          onConfirm={RestoreAll}
          confirmClass="btn-green"
          confirmText="Restore"
          denyText="Cancel"
        />

        <button
          className="standard-button back-button"
          onClick={() => {
            router("/dashboard");
          }}
        >
          <ArrowSvg class={"svg"} />
          Go Back
        </button>

        {/* <button className="standard-button" onClick={DeleteSelected}>
          Select
        </button> */}

        <button className="standard-button" onClick={onRestoreAllClick}>
          Restore All
        </button>

        <button className="standard-button" onClick={onDeleteAllClick}>
          Delete All
        </button>

        {/* <button className="standard-button" disabled onClick={RestoreAll}>
          Restore Selected
        </button>
        <button className="standard-button" disabled onClick={DeleteSelected}>
          Delete Selected
        </button> */}
      </div>
    );
  } else {
    return (
      <div className="dashboard-buttons">
        <button className="standard-button" onClick={props.forwardFileUploadClick}>
          Upload File
        </button>
        <input id="hidden-file-upload" type="file" onChange={props.uploadFile} />

        {/* <button className="standard-button" onClick={props.forwardFolderUploadClick}>
          Upload Folder
        </button>
        <input id="hidden-folder-upload" type="file" webkitdirectory={1} mozdirectory={1} directory={1} /> */}

        <button className="standard-button" onClick={props.createFolder}>
          Create Folder
        </button>
      </div>
    );
  }
}
